import http from "../../../../util/axios";

export default {
  //查询通知类型列表
  queryNotificationTypes(params){
    return http.get('/app/user/queryNotificationTypes',{params})
  },

  //分页查询通知列表
  pageQueryNotifications(data){
    return http.post('/app/user/pageQueryNotifications',data)
  },

  //查询通知详情
  queryNotificationDetail(params){
    return http.get('/app/user/queryNotificationDetail',{params})
  }
}



// WEBPACK FOOTER //
// ./src/api/user/course/notice/index.js